import storage from '../../utils/local-storage';
import logger from '../../utils/logger';
import shortid from 'shortid';

export const EMITTER_KEY = 'batchEmitter';
const EMITTER_TIMESTAMP_KEY = 'batchEmitterTimestamp';

export const initializeEmitter = (): string => {
  // Generate a new emitter
  const newEmitter = shortid.generate();
  logger.log('Generated new emitter:', newEmitter);
  return newEmitter;
};

export const storeEmitter = (emitter: string): void => {
  logger.log('Store emitter:', emitter);
  storage.setItem(EMITTER_KEY, emitter);
  storage.setItem(EMITTER_TIMESTAMP_KEY, Date.now());
};
